import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { firstValueFrom as _fvf, firstValueFrom } from 'rxjs';
import { IService } from '../../../../core/interfaces/i.service.interface';
import { IResponse } from '../../../../core/interfaces/response.interface';
import { environment } from '../../../../../environments/environment';
import { IBlog } from '../../home-page/interface';
@Injectable({ providedIn: 'root' })
export class BlogService implements IService {
  _baseUrl: string = '';
  constructor(private http: HttpClient) { }

  getBlogList(lang: string) {

    return firstValueFrom(
      this.http.get<IBlog[]>(
        `${environment.front.href}/articles/${lang}/manifest.json`,
        {
          headers: {
            'Cache-Control': 'public, max-age=3600',
          },
        },
      ),
    );
  }

  getBostDetails(lang: string, id: string) {
    return firstValueFrom(
      this.http.get(
        `${environment.front.href}/articles/${lang}/${id}.html`,
        {
          responseType: 'text' as const,
          headers: {
            'Accept': 'text/html'
          },
        },
      ),
    );
  }

}
